module.exports = __webpack_public_path__ + "img/lcbz1.ed2702cc.png";